import styled from 'styled-components';

export const HeaderWrapper = styled.header`
  top-margin: 15px;
  height: 10vh;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .iconLogout{
    width: 40%;
  }
`;